import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { SportsbookIntegrationService } from '~/pages/sportsbook-integration/sportsbook-integration.service';
import { HelperPlus2Service } from '~/core/services/helper-plus2.service';
import { CompanyService } from '~/core/services/company.service';
import { isDesktop } from '~/core/helpers/device-utils';
import { WindowHeaderComponent } from '~/containers/window-header/window-header.component';
import { WindowDesktopComponent } from './window-desktop/window-desktop.component';
import { WindowMobileComponent } from './window-mobile/window-mobile.component';
import { PortalSportsbookService } from '~/core/services/portal-sportsbook.service';

@Component({
  selector: 'app-window',
  templateUrl: './window.component.html',
  styleUrls: ['./window.component.scss'],
  standalone: true,
  imports: [WindowHeaderComponent, WindowDesktopComponent, WindowMobileComponent],
})
export class WindowPlus2Component implements OnInit {
  private readonly sportsbookIntegrationService = inject(SportsbookIntegrationService);
  protected router = inject(Router);
  protected readonly portalSportsbookService = inject(PortalSportsbookService);

  get isIframeMode() {
    return this.sportsbookIntegrationService.isIframe;
  }

  isDesktopView: boolean = isDesktop();
  resizeSub: Subscription;
  lastIsDesktop: boolean;

  constructor() {}

  ngOnInit() {
    this.lastIsDesktop = isDesktop();
    this.isDesktopView = this.lastIsDesktop;

    this.resizeSub = fromEvent(window, 'resize')
      .pipe(debounceTime(200))
      .subscribe(() => this.checkDesktopChange());

    const locationHref = window.location.href;
    // TODO(MIGRATION-WINDOW-CASINO-NAMESPACE): CompanyService.getLotteryCasinoNameSpace stays until migrated
    HelperPlus2Service.isPlayingCasino =
      locationHref.includes(`${CompanyService.getLotteryCasinoNameSpace.url_name}/play`) ||
      locationHref.includes(`${CompanyService.getLotteryCasinoNameSpace.live_url}/play`);
    if (locationHref.includes(`sportsbook`)) {
      sessionStorage.setItem('casinoOff', 'true');
    }
  }

  private checkDesktopChange(): void {
    const current = isDesktop();
    if (current !== this.lastIsDesktop) {
      this.lastIsDesktop = current;
      this.isDesktopView = current;
    }
  }
}
